export default __webpack_public_path__ + "3d4cbbd8ce9d59f03c69106e12be80d6.png";